import React from "react";
import _ from "lodash";
import {parseResponse} from "../../../utils/api";
import {AGGREGATED_PORTFOLIO_ID} from "../../../utils/utils";
import {generateQueryParamsHash} from "../utils";
import {useTabsSharedDataContext} from "../components_v2/TabsSharedData/TabsSharedData";
import {isCancel, useCancelableRequest} from "../../../hooks/useCancelableRequest";

export function useDepotFinancialData(
  customerId, portfolios, startDate, endDate, withHistorical, excludedDepotId, dataProvider, withOtherAssets, withLiabilities, data_key='depots-financial-data', withTotal) {

  const [data, setData] = React.useState({
    data: null,
    loading: true,
    error: null,
    updatedAt: +new Date(),
  });
  const getCancelToken = useCancelableRequest();

  const paramsForHash = [startDate, endDate, withHistorical, withOtherAssets, withLiabilities];
  const sharedData = useTabsSharedDataContext();

  const fetch = async () => {
    const cancelToken = getCancelToken();  // run it before set new _setState - to cancel prev fetch

    const hashKey = generateQueryParamsHash(customerId, portfolios, ...paramsForHash);
    const _setState = (state, onlyCache=false) => {
      // It is not possible to sync data with shared data in
      // hook because hook is not executed if component destroyed
      if(!onlyCache) setData(state);
      sharedData.setDataValue(data_key, hashKey, state);
    };

    _setState({
      data: null,
      loading: true,
      error: null,
      updatedAt: +new Date()
    });

    try {
      const portfoliosIds = _.isEmpty(portfolios)
        ? [AGGREGATED_PORTFOLIO_ID] // Use aggregated depot id in case customer does not have active depots
        : portfolios.map((portfolio) => portfolio.depotNumber);
      const response = await dataProvider.getDepotFinancialData(
        customerId, portfoliosIds, startDate, endDate, withHistorical, undefined, undefined,
        excludedDepotId, withOtherAssets, withLiabilities, cancelToken, withTotal);
      parseResponse(response, 'financial', (data) => {
        _setState({
          data: data,
          loading: false,
          error: null,
          updatedAt: +new Date()
        })
      }, (error) => {
        _setState({
          data: null,
          loading: false,
          error: error,
          updatedAt: +new Date()
        })
      })
    } catch (error) {
      _setState({
        data: null,
        loading: false,
        error: error,
        updatedAt: +new Date()
      }, isCancel(error))
    }
  };

  React.useEffect(() => {
    if (!!customerId && !_.isNil(portfolios)) {
      const sharedPortfolioData = !!sharedData
        ? sharedData.getDataValue(data_key, generateQueryParamsHash(customerId, portfolios, ...paramsForHash))
        : undefined;

      // fetch data if there is no shared data or shared data was loaded with error
      if (!!sharedPortfolioData && !sharedPortfolioData.error) {
        // sync internal hook data with shared data.
        setData(sharedPortfolioData);
      } else {
        fetch();
      }
    }
  }, [customerId, JSON.stringify(portfolios), startDate, endDate, withHistorical, withOtherAssets]);

  return [data, fetch]

}